import { Component, OnInit, ViewEncapsulation, PLATFORM_ID, NgZone, Inject, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { BigNumber } from "ethers";
import { Router, ActivatedRoute, Params } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import nftItemsLocale from 'assets/json/nftItems.json'
import { ToastService } from 'app/services/toast-wrapper/toast-wrapper.service';
import { UserService } from 'app/services/user/user.service';
import { Web3Service } from 'app/services/web3/web3.service';
import { MarketplaceService } from 'app/services/contract/contracts-services/marketplace.service';
import { NFTv2Service } from 'app/services/contract/contracts-services/nft.service';
import { NFTItemService } from 'app/services/contract/contracts-services/nft-item.service';
import { contractAddress } from 'app/services/contract/contract.config';
import { environment } from 'environments/environment';
@Component({
  selector: 'app-assets-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AssetDetailsComponent implements OnInit {

  // public account
  public pi
  public craftingLevels: any = [{ level: 1 }, { level: 2 }, { level: 3 }, { level: 4 }, { level: 5 }]
  public otherItems: any = []
  public filterItemCategory
  public otherItemsBuy: any = []
  public allItems: any = []
  public filterAuction
  public showTransferModal
  public isSuccess
  public receiverAddress
  public validAddress
  public isLoading
  public showSaleModal
  public showConfirmationListing
  public listingPrice
  public expirationDate
  public confirmPrice
  public kmonPrice
  public expirationDateUnix
  public kmonValue
  public usdPrice
  public detailsParsed
  public itemsOpenOrder
  public itemAmount: number = 1;
  wallet: string;
  nftItemAddress: string;
  public ingameItems: any = [
    {
      itemType: "LOOTBOX_BASIC",
      val: 0,
      id: '0x4c4f4f54424f585f424153494300000000000000000000000000000000000000',
      img: "./assets/img/Icon/lootbox-bronze.png",
      titleFormatted: "lootbox bronze",
      descriptionFormatted: "The bare minimum collection of items, with these box you'll be capable to keep your friend fed",
      typeFormatted: "consumable",
      baseUrl: "items"
    },
    {
      itemType: "LOOTBOX_MEDIUM",
      val: 0,
      id: '0x4c4f4f54424f585f4d454449554d000000000000000000000000000000000000',
      img: "./assets/img/Icon/lootbox-silver.png",
      titleFormatted: "lootbox silver",
      descriptionFormatted: "The good compromise, with the Silver Box you get enough items to keep your friend fed and happy for some days!",
      typeFormatted: "consumable",
      baseUrl: "items"
    },
    {
      itemType: "LOOTBOX_PREMIUM",
      val: 0,
      id: '0x4c4f4f54424f585f5052454d49554d0000000000000000000000000000000000',
      img: "./assets/img/Icon/lootbox-gold.png",
      titleFormatted: "lootbox gold",
      descriptionFormatted: "Only the best of the best, you'll be able to keep your Kryptomon healthy, fed and happy and boost in training.",
      typeFormatted: "consumable",
      baseUrl: "items"
    },
    {
      itemType: "UNFREEZE_POTION",
      val: 0,
      id: '0x554e465245455a455f504f54494f4e0000000000000000000000000000000000',
      img: "./assets/img/Icon/unfreeze-potion.png",
      titleFormatted: "unfreeze potion",
      descriptionFormatted: "This special potion comes always useful, when your Kryptomon freeze give them this potion to revitilize them.",
      typeFormatted: "consumable",
      baseUrl: "items"
    },
    {
      itemType: "DIAMOND_STORY_CHEST",
      val: 0,
      id: '0x4449414d4f4e445f53544f52595f434845535400000000000000000000000000',
      img: "./assets/img/Icon/lootbox-diamond.png",
      titleFormatted: "lootbox diamond",
      descriptionFormatted: "This chest is full of useful battle potions, they will come useful during your journey.",
      typeFormatted: "battle consumable",
      baseUrl: "items"
    },
    {
      itemType: "BATTLE_STAMINA_POTION",
      val: 0,
      id: '0x424154544c455f5354414d494e415f504f54494f4e0000000000000000000000',
      img: "./assets/img/Icon/battle_stamina_potion.png",
      titleFormatted: "battle stamina potion",
      descriptionFormatted: "This special potion allows you to replay a story challenge stage.",
      typeFormatted: "battle consumable",
      baseUrl: "items"
    },
    {
      itemType: "food-boost-token",
      val: 0,
      id: '2041694201525630780780247644590609268736',
      img: "./assets/img/nftItems/food-boost-token.png",
      titleFormatted: "Food Boost Token",
      descriptionFormatted: "Used to upgrade your food power up.",
      typeFormatted: "crafting material",
      kind: "nft",
      baseUrl: "_items"
    },
    {
      itemType: "health-boost-token",
      val: 0,
      id: '2381976568446569244243622252022377480192',
      img: "./assets/img/nftItems/health-boost-token.png",
      titleFormatted: "Health Boost Token",
      descriptionFormatted: "Used to upgrade your health  power up.",
      typeFormatted: "crafting material",
      kind: "nft",
      baseUrl: "_items"
    },
    {
      itemType: "toy-boost-token",
      val: 0,
      id: '2722258935367507707706996859454145691648',
      img: "./assets/img/nftItems/toy-boost-token.png",
      titleFormatted: "Toy Boost Token",
      descriptionFormatted: "Used to upgrade your caring power up.",
      typeFormatted: "crafting material",
      kind: "nft",
      baseUrl: "_items"
    },
    {
      itemType: "training-boost-token",
      val: 0,
      id: '3062541302288446171170371466885913903104',
      img: "./assets/img/nftItems/training-boost-token.png",
      titleFormatted: "Training Boost Token",
      descriptionFormatted: "Used to upgrade your training power up.",
      typeFormatted: "crafting material",
      kind: "nft",
      baseUrl: "_items"
    }
  ];
  marketplaceProxyAddress: string;
  KMONAddress: string;
  amountTransfer: number = 1;

  constructor(
    private toastService: ToastService,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private userService: UserService,
    private web3Service: Web3Service,
    private nftv2Service: NFTv2Service,
    private marketplaceService: MarketplaceService,
    private nftItemService: NFTItemService
  ) {

    this.showTransferModal = false;
    this.isSuccess = false;
    this.validAddress = false;
    this.isLoading = false;
    this.showSaleModal = false
    this.showConfirmationListing = false
    this.kmonPrice = 0;
    this.usdPrice = 0;
    this.expirationDateUnix = 0;
    this.detailsParsed = false;

    this.marketplaceProxyAddress = contractAddress[this.web3Service.getNetworkName()].MarketplaceProxy;
    this.KMONAddress = contractAddress[this.web3Service.getNetworkName()].KMON;
    this.nftItemAddress = contractAddress[this.web3Service.getNetworkName()].NFTItems;

  }

  async populateRouter(id) {
    var regExp = /[a-zA-Z]/g;
    if (regExp.test(id)) {
      this.populatePageConsumable(id)
    } else {
      this.populatePageNFT(id)
      this.ingameItems.reverse();
    }
    this.parseSimilarItems()
    await this.http.get("https://api.coingecko.com/api/v3/simple/price?ids=kryptomon,wbnb&vs_currencies=bnb,usd&precision=18").subscribe((item: any) => {
      console.log(item);
      this.kmonValue = item.kryptomon.usd;
    })
  }

  populatePageNFT(id) {
    this.detailsParsed = false;
    this.allItems = []
    this.otherItems = [];
    this.pi = {}
    //this.allItems = []
    this.http.get(environment.apiBaseUrlV22 + "user/" + this.wallet + "/nft-items?limit=1000").subscribe(async (responseNFT: any) => {
      console.log(responseNFT)
      let allItems = responseNFT
      console.log(allItems)
      for (let i = 0; i < allItems.length; i++) {

        let newObject: any = {}
        if (allItems[i].itemId) {
          newObject.kind = "nft";
          newObject.itemId = allItems[i].itemId;
          newObject.metadata = allItems[i].metadata;
          newObject.balance = allItems[i].balance
          newObject.metadata.nameFormatted = nftItemsLocale[allItems[i].metadata.name + '-name']
          newObject.metadata.descriptionFormatted = nftItemsLocale[allItems[i].metadata.name + '-description']

          if (allItems[i].metadata.properties.scope == "equip") {
            newObject.metadata.typeFormatted = "equipment"
            if (allItems[i].metadata.name.indexOf("guardian") > -1) {
              newObject.metadata.descriptionFormatted = nftItemsLocale["guardian-description"]
            } else if (allItems[i].metadata.name.indexOf("conqueror") > -1) {
              newObject.metadata.descriptionFormatted = nftItemsLocale["conqueror-description"]
            } else if (allItems[i].metadata.name.indexOf("vanquisher") > -1) {
              newObject.metadata.descriptionFormatted = nftItemsLocale["vanquisher-description"]
            }

          } else if (allItems[i].metadata.properties.category == "caring-boost" && allItems[i].metadata.properties.type !== "material") {
            newObject.metadata.typeFormatted = "caring boost"
          } else if (allItems[i].metadata.properties.category == "treasure-hunt") {
            newObject.metadata.typeFormatted = "hunting boost"
          } else if (allItems[i].metadata.properties.type === "material") {
            newObject.metadata.typeFormatted = "crafting material"
          } else if (allItems[i].metadata.properties.category === "badge") {
            newObject.metadata.typeFormatted = "badge"
          } else if (allItems[i].metadata.properties.category === "currency") {
            newObject.metadata.typeFormatted = "special currency"
          }

          if (allItems[i].metadata.properties.category == "caring-boost" && allItems[i].metadata.properties.type !== "material") {
            allItems[i].metadata.name = "powerup-" + allItems[i].metadata.name
          }

          if (/\d/.test(allItems[i].metadata.name)) {
            newObject.craftingStage = allItems[i].metadata.name.match(/\d+/)[0] // "3"
            newObject.craftingMax = 5;
            newObject.craftingPercentage = Math.round(newObject.craftingStage / newObject.craftingMax * 100)
          }

        } else {
          newObject.kind = "consumable";
          newObject.balance = allItems[i].count
          newObject.itemId = allItems[i].type;
          newObject.metadata = {}
          newObject.metadata.name = allItems[i].type;
          newObject.metadata.descriptionFormatted = nftItemsLocale[allItems[i].type]
          newObject.metadata.properties = {}
          newObject.metadata.properties.category = "consumable"
          if (newObject.itemId == "BATTLE_STAMINA_POTION") {
            newObject.metadata.nameFormatted = "battle stamina potion"
            newObject.metadata.image = "./assets/img/Icon/battle_stamina_potion.png"
            newObject.metadata.typeFormatted = "replay potion"
          } else if (newObject.itemId == "DIAMOND_STORY_CHEST") {
            newObject.metadata.nameFormatted = "diamond story chest"
            newObject.metadata.image = "./assets/img/Icon/lootbox-diamond.png"
            newObject.metadata.typeFormatted = "consumable box"
            newObject.metadata.name = "DIAMOND_STORY_LOOTBOX";
          } else if (newObject.itemId == "LOOTBOX_BASIC") {
            newObject.metadata.nameFormatted = "lootbox bronze"
            newObject.metadata.image = "./assets/img/Icon/lootbox-bronze.png"
            newObject.metadata.typeFormatted = "consumable box"
          } else if (newObject.itemId == "LOOTBOX_MEDIUM") {
            newObject.metadata.nameFormatted = "lootbox silver"
            newObject.metadata.image = "./assets/img/Icon/lootbox-silver.png"
            newObject.metadata.typeFormatted = "consumable box"
          } else if (newObject.itemId == "LOOTBOX_PREMIUM") {
            newObject.metadata.nameFormatted = "lootbox gold"
            newObject.metadata.image = "./assets/img/Icon/lootbox-gold.png"
            newObject.metadata.typeFormatted = "consumable box"
          } else if (newObject.itemId == "UNFREEZE_POTION") {
            newObject.metadata.nameFormatted = "unfreeze potion"
            newObject.metadata.image = "./assets/img/Icon/unfreeze-potion.png"
            newObject.metadata.typeFormatted = "consumable item"
          }
        }
        newObject.itemTypeId = allItems[i].itemTypeId;
        if (allItems[i].itemId == id) {
          this.pi = newObject;
          this.filterItemCategory = newObject.metadata.typeFormatted
          this.allItems.push(newObject)
        } else {
          this.otherItems.push(newObject)
          this.allItems.push(newObject)
        }

      }
      //this.allItems = this.otherItems;

      this.checkOpenOrder()
    })

  }


  checkOpenOrder() {
    this.http.get(environment.apiBaseUrlV22 + "orders/1155/open?owner=" + this.wallet).subscribe((item: any) => {
      console.log(item)
      if (item.orders.length > 0) {
        for (let i = 0; i < item.orders.length; i++) {
          if (this.pi.itemId == item.orders[i].assetId) {
            this.pi.order = item.orders[i];
            this.pi.order.priceFormatted = parseFloat(this.web3Service.getWeb3().utils.fromWei(item.orders[i].priceInWei))
          }
        }
        for (let i = 0; i < item.orders.length; i++) {
          for (let x = 0; x < this.otherItems.length; x++) {
            if (this.otherItems[x].itemId == item.orders[i].assetId) {
              this.otherItems[x].order = item.orders[i];
              this.otherItems[x].order.priceFormatted = parseFloat(this.web3Service.getWeb3().utils.fromWei(item.orders[i].priceInWei))
            }
          }
        }
      }
      this.detailsParsed = true;
    })
  }


  populatePageConsumable(id) {

    this.http.get(environment.apiBaseUrlV22 + "user/" + this.wallet + "/items?limit=1000").subscribe(async (responseNFT: any) => {
      console.log(responseNFT)
      let allItems = responseNFT
      console.log(allItems)
      for (let i = 0; i < allItems.length; i++) {
        if (allItems[i].type == id) {

          let newObject: any = {}
          if (allItems[i].itemId) {
            newObject.kind = "nft";
            newObject.itemId = allItems[i].itemId;
            newObject.metadata = allItems[i].metadata;
            newObject.balance = allItems[i].balance
            newObject.metadata.nameFormatted = nftItemsLocale[allItems[i].metadata.name + '-name']
            newObject.metadata.descriptionFormatted = nftItemsLocale[allItems[i].metadata.name + '-description']

            if (allItems[i].metadata.properties.scope == "equip") {
              newObject.metadata.typeFormatted = "equipment"
              if (allItems[i].metadata.name.indexOf("guardian") > -1) {
                newObject.metadata.descriptionFormatted = nftItemsLocale["guardian-description"]
              } else if (allItems[i].metadata.name.indexOf("conqueror") > -1) {
                newObject.metadata.descriptionFormatted = nftItemsLocale["conqueror-description"]
              } else if (allItems[i].metadata.name.indexOf("vanquisher") > -1) {
                newObject.metadata.descriptionFormatted = nftItemsLocale["vanquisher-description"]
              }

            } else if (allItems[i].metadata.properties.category == "caring-boost" && allItems[i].metadata.properties.type !== "material") {
              newObject.metadata.typeFormatted = "caring boost"
            } else if (allItems[i].metadata.properties.category == "treasure-hunt") {
              newObject.metadata.typeFormatted = "hunting boost"
            } else if (allItems[i].metadata.properties.type === "material") {
              newObject.metadata.typeFormatted = "crafting material"
            } else if (allItems[i].metadata.properties.category === "badge") {
              newObject.metadata.typeFormatted = "badge"
            }

            if (allItems[i].metadata.properties.category == "caring-boost" && allItems[i].metadata.properties.type !== "material") {
              allItems[i].metadata.name = "powerup-" + allItems[i].metadata.name
            }

            if (/\d/.test(allItems[i].metadata.name)) {
              newObject.craftingStage = allItems[i].metadata.name.match(/\d+/)[0] // "3"
              newObject.craftingMax = 5;
              newObject.craftingPercentage = Math.round(newObject.craftingStage / newObject.craftingMax * 100)
            }

          } else {
            newObject.kind = "consumable";
            newObject.balance = allItems[i].count
            newObject.itemId = allItems[i].type;
            newObject.metadata = {}
            newObject.metadata.name = allItems[i].type;
            newObject.metadata.descriptionFormatted = nftItemsLocale[allItems[i].type]
            newObject.metadata.properties = {}
            newObject.metadata.properties.category = "consumable"
            if (newObject.itemId == "BATTLE_STAMINA_POTION") {
              newObject.metadata.nameFormatted = "battle stamina potion"
              newObject.metadata.image = "./assets/img/Icon/battle_stamina_potion.png"
              newObject.metadata.typeFormatted = "replay potion"
            } else if (newObject.itemId == "DIAMOND_STORY_CHEST") {
              newObject.metadata.nameFormatted = "diamond story chest"
              newObject.metadata.image = "./assets/img/Icon/lootbox-diamond.png"
              newObject.metadata.typeFormatted = "consumable box"
              newObject.metadata.name = "DIAMOND_STORY_LOOTBOX";
            } else if (newObject.itemId == "LOOTBOX_BASIC") {
              newObject.metadata.nameFormatted = "lootbox bronze"
              newObject.metadata.image = "./assets/img/Icon/lootbox-bronze.png"
              newObject.metadata.typeFormatted = "consumable box"
            } else if (newObject.itemId == "LOOTBOX_MEDIUM") {
              newObject.metadata.nameFormatted = "lootbox silver"
              newObject.metadata.image = "./assets/img/Icon/lootbox-silver.png"
              newObject.metadata.typeFormatted = "consumable box"
            } else if (newObject.itemId == "LOOTBOX_PREMIUM") {
              newObject.metadata.nameFormatted = "lootbox gold"
              newObject.metadata.image = "./assets/img/Icon/lootbox-gold.png"
              newObject.metadata.typeFormatted = "consumable box"
            } else if (newObject.itemId == "UNFREEZE_POTION") {
              newObject.metadata.nameFormatted = "unfreeze potion"
              newObject.metadata.image = "./assets/img/Icon/unfreeze-potion.png"
              newObject.metadata.typeFormatted = "consumable item"
            }
          }
          this.pi = newObject;
        }

      }
      console.log(this.pi)
    })

  }

  parseSimilarItems() {
    this.http.get(environment.apiBaseUrlV22 + "orders/1155/groups").subscribe((item: any) => {
      console.log(item)
      let tokenArray: any = []
      let itemsSaleArray = []
      let allItems = item.data.order1155Groups;
      for (let i = 0; i < allItems.length; i++) {
        let newObject: any = {}
        newObject.kind = "nft";
        newObject.itemId = allItems[i].itemType.itemTypeId;
        newObject.metadata = allItems[i].itemType.metadata;
        newObject.balance = allItems[i].quantity;
        newObject.metadata.nameFormatted = nftItemsLocale[allItems[i].itemType.metadata.name + '-name']
        newObject.metadata.descriptionFormatted = nftItemsLocale[allItems[i].itemType.metadata.name + '-description']

        if (allItems[i].itemType.metadata.properties.scope == "equip") {
          newObject.metadata.typeFormatted = "equipment"
          if (allItems[i].itemType.metadata.name.indexOf("guardian") > -1) {
            newObject.metadata.descriptionFormatted = nftItemsLocale["guardian-description"]
          } else if (allItems[i].itemType.metadata.name.indexOf("conqueror") > -1) {
            newObject.metadata.descriptionFormatted = nftItemsLocale["conqueror-description"]
          } else if (allItems[i].itemType.metadata.name.indexOf("vanquisher") > -1) {
            newObject.metadata.descriptionFormatted = nftItemsLocale["vanquisher-description"]
          }

        } else if (allItems[i].itemType.metadata.properties.category == "caring-boost" && allItems[i].itemType.metadata.properties.type !== "material") {
          newObject.metadata.typeFormatted = "caring boost"
        } else if (allItems[i].itemType.metadata.properties.category == "treasure-hunt") {
          newObject.metadata.typeFormatted = "hunting boost"
        } else if (allItems[i].itemType.metadata.properties.type === "material") {
          newObject.metadata.typeFormatted = "crafting material"
        } else if (allItems[i].itemType.metadata.properties.category === "badge") {
          newObject.metadata.typeFormatted = "badge"
        }

        if (allItems[i].itemType.metadata.properties.category == "caring-boost" && allItems[i].itemType.metadata.properties.type !== "material") {
          allItems[i].itemType.metadata.name = "powerup-" + allItems[i].itemType.metadata.name
        }

        if (/\d/.test(allItems[i].itemType.metadata.name)) {
          newObject.craftingStage = allItems[i].itemType.metadata.name.match(/\d+/)[0] // "3"
          newObject.craftingMax = 5;
          newObject.craftingPercentage = Math.round(newObject.craftingStage / newObject.craftingMax * 100)
        }
        this.otherItemsBuy.push(newObject)
      }
      /*for(let i = 0; i<this.allItems.length;i++){
        let currentName = this.allItems[i].metadata.name
        if(currentName.indexOf("powerup-")>-1){
          currentName = currentName.replace("powerup-","")
        }
        let nameSplit =  currentName.split("-")
        nameSplit.pop()
        let itemNameCheck = nameSplit.join('-')
        this.allItems[i].metadata.nameCheck = nameSplit.join('-');
      }*/

      /*for(let i = 0; i<item.data.order1155Groups.length;i++){
        //console.log(item.data.order1155Groups[i].itemType.metadata.name)
        if(item.data.order1155Groups[i].itemType.metadata.name.indexOf('token')>=0 || item.data.order1155Groups[i].itemType.metadata.name.indexOf('scraps')>=0){
          tokenArray.push(item.data.order1155Groups[i])
        }
      }*/
      //this.otherItemsBuy = item.data.order1155Groups.filter(item=>!this.allItems.some(itemToBeRemoved => item.itemType.metadata.name.indexOf(itemToBeRemoved.metadata.nameCheck)>=0))
      //this.otherItemsBuy = this.otherItemsBuy.concat(tokenArray)
      console.log(this.otherItemsBuy)
    })
  }
  //&& (item.data.order1155Groups[x].itemType.metadata.name.indexOf('token')<0 && item.data.order1155Groups[x].itemType.metadata.name.indexOf('scraps')<0)
  //0x203A130d9a0799d95E741911049A0B77b076137d

  async checkAllowanceItems() {
    this.isLoading = true;
    // let allowance = await this.appComponent.contractService.contractInstanceV2.methods.isApprovedForAll(this.wallet, this.nftItemAddress).call();
    this.nftItemService.isApprovalForAll(this.wallet, this.nftItemAddress).subscribe(
      allowance => {
        console.log(allowance)
        if (allowance) {
          this.initiateTransfer()
        } else {
          this.nftItemService.setApprovalForAll(this.wallet, this.nftItemAddress, true).subscribe(
            (result) => {
              console.log(result)
              if (result.events.ApprovalForAll !== undefined) {
                this.initiateTransfer()
              } else {
                this.isLoading = false;
                //this.loadingTxKryptomon = false;
                this.toastService.genericError();
              }
            }, (err) => {
              this.isLoading = false;
              //this.loadingTxKryptomon = false;
              console.log('allowance failed')
              this.toastService.genericError();
            }
          )




          // this.appComponent.contractService.contractInstanceV2.methods.setApprovalForAll(this.nftItemAddress, true).send({...this.contractsService.additionalParameters(), 
          //   from: this.account
          // }).then((result) => {
          //   console.log(result)
          //   if (result.events.ApprovalForAll !== undefined) {
          //     this.initiateTransfer()
          //   } else {
          //     this.isLoading = false;
          //     //this.loadingTxKryptomon = false;
          //     this.toastr.error('Try again, or contact our team for support', 'Ops! Something went wrong', { timeOut: 5000 })
          //   }
          // }).catch((err) => {
          //   this.isLoading = false;
          //   //this.loadingTxKryptomon = false;
          //   console.log('allowance failed')
          //   this.toastr.error('Try again, or contact our team for support', 'Ops! Something went wrong', { timeOut: 5000 })
          // });;
        }
      }
    )

  }

  async initiateTransfer() {
    console.log(this.pi.itemId)
    this.isLoading = true;
    this.nftItemService.safeBatchTransferFrom(this.wallet, this.receiverAddress, [this.pi.itemId], [this.amountTransfer], []).subscribe(
      (item) => {
        if (item.events.TransferBatch) {
          window.localStorage.setItem('somethingChanged', 'true')
          /*this.kryptomonsV2Navigation = this.kryptomonsV2Navigation.filter((item)=> {
            return item.tokenId !== this.kryptomon.tokenId
          })
          this.kryptomonsV2 = this.kryptomonsV2Navigation;*/

          this.isSuccess = true;
          this.isLoading = false;
          this.amountTransfer = 1;
        } else {
          this.isSuccess = false;
          this.isLoading = false;
          this.toastService.genericError();
        }
        console.log(item);
      }, (err) => {
        this.isSuccess = false;
        this.isLoading = false;
        this.toastService.genericError();
      }
    );
    // this.appComponent.contractService.contractInstanceV2.methods.safeBatchTransferFrom(this.account, this.receiverAddress, [this.pi.itemId], [1], []).send({...this.contractsService.additionalParameters(), 
    //   from: this.account
    // }).then((item) => {
    //   if (item.events.TransferBatch) {
    //     window.localStorage.setItem('somethingChanged', 'true')
    //     /*this.kryptomonsV2Navigation = this.kryptomonsV2Navigation.filter((item)=> {
    //       return item.tokenId !== this.kryptomon.tokenId
    //     })
    //     this.kryptomonsV2 = this.kryptomonsV2Navigation;*/

    //     this.isSuccess = true;
    //     this.isLoading = false;
    //   } else {
    //     this.isSuccess = false;
    //     this.isLoading = false;
    //     this.toastr.error('Try again, or contact our team for support', 'Ops! Something went wrong', { timeOut: 5000 });
    //   }
    //   console.log(item);
    // }, (err) => {
    //   this.isSuccess = false;
    //   this.isLoading = false;
    //   this.toastr.error('Try again, or contact our team for support', 'Ops! Something went wrong', { timeOut: 5000 });
    // })
  }
  closeTransferProcedure() {
    this.showTransferModal = false;
    this.isSuccess = false;
    this.router.navigate(["/assets"])
  }

  isValidAddressKmon() {
    this.validAddress = this.web3Service.isValidAddress(this.receiverAddress);// this.appComponent.contractService.web3.utils.isAddress(this.receiverAddress);
  }

  updateKMONPrice() {
    let kmonPrice = this.listingPrice * this.kmonValue;
    console.log(kmonPrice)
    if (kmonPrice >= 1000) {
      this.usdPrice = (Math.round(kmonPrice / 1000 * 100) / 100).toLocaleString() + "K"
    } else {
      this.usdPrice = (Math.round(kmonPrice * 100) / 100).toLocaleString()
    }
  }

  checkDateValidity($event) {
    let selectedDate = new Date($event);
    let today = new Date()
    if (selectedDate > today) {
      this.expirationDateUnix = selectedDate.getTime();
    } else {
      this.expirationDateUnix = 0;
    }
  }

  async initiateSaleListing() {
    this.isLoading = true;
    this.nftItemService.isApprovalForAll(this.wallet, this.marketplaceProxyAddress).subscribe(
      allowance => {
        if (allowance) {
          this.executeListing()
        } else {
          this.nftItemService.setApprovalForAll(this.wallet, this.marketplaceProxyAddress, true).subscribe(
            (result) => {
              console.log(result)
              if (result.events.ApprovalForAll !== undefined) {
                this.executeListing()
              } else {
                this.isLoading = false;
                //this.loadingTxKryptomon = false;
                this.toastService.genericError();
              }
            }, (err) => {
              this.isLoading = false;
              //this.loadingTxKryptomon = false;
              console.log('allowance failed')
              this.toastService.genericError();
            }
          );

        }
      }
    );











    // let allowance = await this.appComponent.contractService.contractInstanceV2.methods.isApprovedForAll(this.account, this.marketplaceProxyAddress).call();
    // console.log(allowance)
    // if (allowance) {
    //   this.executeListing()
    // } else {
    //   this.appComponent.contractService.contractInstanceV2.methods.setApprovalForAll(this.marketplaceProxyAddress, true).send({...this.contractsService.additionalParameters(), 
    //     from: this.account
    //   }).then((result) => {
    //     console.log(result)
    //     if (result.events.ApprovalForAll !== undefined) {
    //       this.executeListing()
    //     } else {
    //       this.isLoading = false;
    //       //this.loadingTxKryptomon = false;
    //       this.toastr.error('Try again, or contact our team for support', 'Ops! Something went wrong', { timeOut: 5000 })
    //     }
    //   }).catch((err) => {
    //     this.isLoading = false;
    //     //this.loadingTxKryptomon = false;
    //     console.log('allowance failed')
    //     this.toastr.error('Try again, or contact our team for support', 'Ops! Something went wrong', { timeOut: 5000 })
    //   });;
    // }
  }

  async executeListing() {

    this.marketplaceService.createOrder1155(this.wallet, this.nftItemAddress, this.pi.itemId, this.itemAmount,
      this.web3Service.toWei(this.listingPrice), this.KMONAddress, this.expirationDateUnix.toString()).subscribe(
        (item) => {
          console.log(item)
          if (item.events.Order1155Created) {
            window.localStorage.setItem('somethingChanged', 'true')
            setTimeout(() => {
              this.isLoading = false;
              this.isSuccess = true;
            }, 5000)
          } else {
            this.isLoading = false;
            this.isSuccess = false;
            this.toastService.genericError();
          }
        },
        (err) => {
          this.toastService.genericError();
          this.isLoading = false;
          this.isSuccess = false;
          console.log(err)
        }
      );


    // this.appComponent.contractService.marketplaceContract.methods.createOrder1155(this.nftItemAddress, this.pi.itemId, 1, this.appComponent.contractService.web3.utils.toWei((this.listingPrice).toString(), 'ether'), "0xc732B6586A93b6B7CF5FeD3470808Bc74998224D", (this.expirationDateUnix).toString()).send({...this.contractsService.additionalParameters(), 
    //   from: this.account
    // }).then((item) => {
    //   console.log(item)
    //   if (item.events.Order1155Created) {
    //     window.localStorage.setItem('somethingChanged', 'true')
    //     setTimeout(() => {
    //       this.isLoading = false;
    //       this.isSuccess = true;
    //     }, 5000)
    //   } else {
    //     this.isLoading = false;
    //     this.isSuccess = false;
    //     this.toastr.error('Try again, or contact our team for support', 'Ops! Something went wrong', { timeOut: 5000 })
    //   }

    // }, (err) => {
    //   this.toastr.error('Try again, or contact our team for support', 'Ops! Something went wrong', { timeOut: 5000 })
    //   this.isLoading = false;
    //   this.isSuccess = false;
    //   console.log(err)
    // })
  }

  closeListingProcedure() {
    this.showSaleModal = false;
    this.isSuccess = false;
    this.showConfirmationListing = false;
    this.populateRouter(this.pi.itemId)
  }

  cancelListing() {
    this.isLoading = true;
    this.marketplaceService.cancelOrder1155(this.wallet, this.nftItemAddress, this.pi.itemId).subscribe(
      (item) => {
        if (item.events.Order1155Cancelled) {
          window.localStorage.setItem('somethingChanged', 'true')
          this.isSuccess = true;
          setTimeout(() => {
            this.isSuccess = false;
            this.pi.order = undefined;
          }, 3000)
        } else {
          this.toastService.genericError();
          this.isSuccess = false;
        }
        this.isLoading = false;
      }, (err) => {
        this.toastService.genericError();
        this.isLoading = false;
        this.isSuccess = false;
      }
    );

    // this.appComponent.contractService.marketplaceContract.methods.cancelOrder1155(this.nftItemAddress, this.pi.itemId).send({...this.contractsService.additionalParameters(), 
    //   from: this.account
    // }).then((item) => {
    //   if (item.events.Order1155Cancelled) {
    //     window.localStorage.setItem('somethingChanged', 'true')
    //     this.isSuccess = true;
    //     setTimeout(() => {
    //       this.isSuccess = false;
    //       this.pi.order = undefined;
    //     }, 3000)
    //   } else {
    //     this.toastr.error('Try again, or contact our team for support', 'Ops! Something went wrong', { timeOut: 5000 })
    //     this.isSuccess = false;
    //   }
    //   this.isLoading = false;
    // }, (err) => {
    //   this.toastr.error('Try again, or contact our team for support', 'Ops! Something went wrong', { timeOut: 5000 })
    //   this.isLoading = false;
    //   this.isSuccess = false;
    // })
  }

  openDetails(item) {
    let id = item.itemId
    this.router.navigate(['/assets/details', id])
  }

  openAuctionHouse(item) {
    let id = item.itemId
    let kind = "_browseItem"
    this.router.navigate(['/shop', kind, id])
  }

  openPrimusBazaar(item) {
    let id = item.id
    let kind = item.baseUrl
    // this.router.navigate(['/shop', kind, id])
    this.router.navigate(['primus-bazaar/company-store', item.itemType.toUpperCase()]);
  }

  openCraft(item) {
    // let id = item.itemId
    // let kind = "_items"
    // let addon = "0"
    // this.router.navigate(['/shop', kind, id, addon])
    this.router.navigate(['quick-craft', item.itemTypeId]);
  }

  ngOnInit(): void {
    this.wallet = this.userService._userInfoData.recordedWallet;
    this.route.params.subscribe(async (params: Params) => {
      var id = params['id']
      if (id != undefined) {
        // if (this.appComponent.accounts == undefined) {
        //   this.appComponent.accountsObservable.subscribe(async (item: any) => {
        //     this.account = item[0];
        //     if (this.account !== undefined && this.account !== "") {
        //       //this.getKmonBalance();
        //       //this.getHatchingTime();
        //       //this.setAllowance()
        //       //this.populatePage(id)
        //       //this.setAllowance();
        //       this.populateRouter(id)

        //       console.log(this.account)
        //     }
        //   });
        // } else {
        //   this.account = this.appComponent.accounts[0];
        //   //this.getKmonBalance();
        //   //this.getHatchingTime();
        //   //this.setAllowance()
        //   //this.populatePage(id)
        //   //this.setAllowance();
        //   this.populateRouter(id)

        //   console.log(this.account)
        // }
        this.populateRouter(id);
      } else {
        this.router.navigate(['/assets'])
      }
    });
    //this.nftItemAddress = contractAddress[this.web3Service.getNetworkName()].NFTItems;
  }

}
